module.exports = __webpack_public_path__ + "media/icons/zabezpieczenia-768bb9c7.png";